<template>
    <svg
        width="9"
        height="5"
        viewBox="0 0 9 5"
        fill="#D8D8F1"
        xmlns="http://www.w3.org/2000/svg"
        class="arrow-down-icon"
    >
        <path d="M1.0575 0L4.5 3.09042L7.9425 0L9 0.951417L4.5 5L0 0.951417L1.0575 0Z" />
    </svg>
</template>

<script>
export default {}
</script>
